import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Tabs,
  title: 'Tabs',
  category: ComponentCategory.Layout,
  droppable: false,
};
